module.exports = __webpack_public_path__ + "images/emoji/saxophone.2e679c1be73a6b4575e2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/saxophone.png
// module id = uLGq
// module chunks = 24